import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

export interface DatosNotificacion {
    tipo: "default" | "info" | "success" | "warning" | "error";
    mensaje: string;
    estaAfueraDeAngular: boolean;
    id?: string;
}

export abstract class NotificacionServiceEmisor {
    public abstract notificarError(mensaje: string, estaAfueraDeAngular?: boolean, id?: string): void;
    public abstract notificarInfo(mensaje: string, estaAfueraDeAngular?: boolean, id?: string): void;
    public abstract notificarExito(mensaje: string, estaAfueraDeAngular?: boolean, id?: string): void;
    public abstract cerrarNotificacion(id: string): void;
}

export abstract class NotificacionServiceReceptor {
    public envioNotificacion$: Observable<DatosNotificacion>;
    public cerrarNotificacion$: Observable<string>;
}

/**
 * @private No usar esta clase
 *
 * Usar:
 * @see NotificacionServiceEmisor Para enviar notificaciones
 * @see NotificacionServiceReceptor Para recibir notificaciones
 */
@Injectable({
    providedIn: "root"
})
export class NotificacionService implements NotificacionServiceEmisor, NotificacionServiceReceptor {
    public envioNotificacion$ = new Subject<DatosNotificacion>();
    public cerrarNotificacion$ = new Subject<string>();

    public notificarError(mensaje: string, estaAfueraDeAngular: boolean = false, id?: string): void {
        this.envioNotificacion$.next({
            tipo: "error",
            mensaje,
            estaAfueraDeAngular,
            id
        });
    }

    public notificarInfo(mensaje: string, estaAfueraDeAngular: boolean = false, id?: string) {
        this.envioNotificacion$.next({
            tipo: "info",
            mensaje,
            estaAfueraDeAngular,
            id
        });
    }

    public notificarExito(mensaje: string, estaAfueraDeAngular: boolean = false, id?: string): void {
        this.envioNotificacion$.next({
            tipo: "success",
            mensaje,
            estaAfueraDeAngular,
            id
        });
    }

    public cerrarNotificacion(id: string): void {
        this.cerrarNotificacion$.next(id);
    }
}
